<script>
import Icon from 'svelte-icon';
import menu from './zondicons/menu.svg'; // https://www.zondicons.com/
import arrowLeft from './zondicons/arrow-left.svg';
import arrowRight from './zondicons/arrow-right.svg';
import { push } from 'svelte-spa-router'

export let selectedPage;

function navigate(e) {
	const href = '/' + e.target.value;
	push(href);
}

function href(page) {
	if (page == null) return;
	return `#/${page.slug}`;
}

</script>

<nav>

	<a class="no-underline" href="#/"><Icon data={menu} size='1em' /></a>

	<a class="no-underline" href="{href(selectedPage.prev)}" class:disabled={!selectedPage.prev}>
		<Icon data={arrowLeft} size="1em" />
	</a>

	<div>
		<span>
			<strong>
				{selectedPage.section.titles.join(' / ')} / 
			</strong>
			{selectedPage.title}
		</span>

		<select value={selectedPage.slug} on:change={navigate}>
			{#each selectedPage.contents.sections as section, i}
				<optgroup label="{i + 1}. {section.titles.join(' / ')}">
					{#each section.questions as page, i}
						<option value={page.slug}>{page.title}</option>
					{/each}
				</optgroup>
			{/each} 
		</select>
	</div>

	<a class="no-underline" href="{href(selectedPage.next)}" class:disabled={!selectedPage.next}>
		<Icon data={arrowRight} size='1em' />
	</a>
</nav>

<style>
	nav {
		display: grid;
		grid-template-columns: 2.5em 2.5em 1fr 2.5em;
		border-bottom: 1px solid rgba(255,255,255,0.1);
		font-size: 80%;
	}

	div {
		position: relative;
		padding: 1em 0.5em;
		font-weight: 300;
		font-size: var(--h6);
		color: white;
	}

	a {
		display: block;
		padding: 0.7em 0;
		text-align: center;
		opacity: 0.75;
		color: white;
	}
	a.no-underline {
		padding: 1.4em 0 1em;
	}

	a:hover {
		opacity: 1;
	}

	a.disabled, a.disabled:hover, a.disabled:active {
		color: white;
		opacity: 0.3;
		cursor: auto;
	}

	span {
		white-space: nowrap;
		position: relative;
    	top: 0.3em;
	}

	strong { opacity: 0.7; font-weight: normal; }

	select {
		position: absolute;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		opacity: 0.0001;
		cursor: pointer;
		-webkit-appearance: none;
	}
</style>

